module.exports = __webpack_public_path__ + "img/logo.40c839ad.svg";